// Info: Import React Dependancies
import { useCallback, useEffect, useState } from "react";

// Info: Import NPM Dependancies
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";

// Info: Import Local Dependancies
import "./App.css";
import { useSiteCore } from "./services/useSiteCoreAPi";
import { getIsSiteCorePending } from "./store/sitecoreSlice";
import ReCaptcha from "./pages/Recaptcha";
import { env } from "./env";

const { adobeBaseUrl } = env;
function App() {
  const { getSiteCore } = useSiteCore();
  const isSiteCorePending = useSelector(getIsSiteCorePending);

  useEffect(() => {
    if (env.isIframe) {
      if (window.self !== window.top) {
        getSiteCore("en");
      }
    } else {
      getSiteCore("en");
    }
  }, []);

  return (
    <>
      <Helmet>
        <script src={adobeBaseUrl} type="text/javascript" />
      </Helmet>
      {!isSiteCorePending ? <ReCaptcha /> : null}
    </>
  );
}

export default App;
